import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import Tooltip from './base/Tooltip';
import StyledEllipsisOverflow from './helpers/EllipsisOverflow';
export function insertMiddleEllipsis(text: string, max_length: number) {
  if (text.length <= max_length) return text;
  const side_length = Math.floor((max_length - 3) / 2);
  return text.slice(0, side_length) + '...' + text.slice(text.length - side_length);
}
export function useTruncatable(t0) {
  const $ = _c(12);
  const {
    text,
    default_width: t1
  } = t0;
  const default_width = t1 === undefined ? 100 : t1;
  const [target, setTarget] = useState(null);
  const [ref_width, setRefWidth] = useState(default_width);
  let t2;
  let t3;
  if ($[0] !== target) {
    t2 = () => {
      if (!target) {
        return;
      }
      const resize_observer = new ResizeObserver(observed => {
        if (observed[0].contentRect.width < 100) {
          return;
        }
        setRefWidth(observed[0].contentRect.width);
      });
      resize_observer.observe(target);
      return () => resize_observer.disconnect();
    };
    t3 = [target];
    $[0] = target;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  if (!text || !ref_width) {
    const t4 = text ?? "";
    let t5;
    if ($[3] !== t4) {
      t5 = [t4, false, setTarget];
      $[3] = t4;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    return t5 as const;
  }
  const should_truncate = ref_width < 100 ? false : text.length / ((ref_width - 24) / 8) > 1;
  let t4;
  if ($[5] !== ref_width || $[6] !== should_truncate || $[7] !== text) {
    t4 = should_truncate ? insertMiddleEllipsis(text, ref_width / 8) : text;
    $[5] = ref_width;
    $[6] = should_truncate;
    $[7] = text;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const display_text = t4;
  const truncated = text !== display_text;
  let t5;
  if ($[9] !== display_text || $[10] !== truncated) {
    t5 = [display_text, truncated, setTarget];
    $[9] = display_text;
    $[10] = truncated;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5 as const;
}
export function Truncatable(t0) {
  const $ = _c(10);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = {
      text
    };
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [display_text, truncated, ref] = useTruncatable(t1);
  let t2;
  if ($[2] !== display_text || $[3] !== text || $[4] !== truncated) {
    t2 = truncated ? <Tooltip tooltip={text} side="bottom">{display_text}</Tooltip> : text;
    $[2] = display_text;
    $[3] = text;
    $[4] = truncated;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== ref || $[7] !== t2 || $[8] !== text) {
    t3 = <StyledEllipsisOverflow ref={ref} as="span" aria-label={text}>{t2}</StyledEllipsisOverflow>;
    $[6] = ref;
    $[7] = t2;
    $[8] = text;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}